/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox, Typography } from '@neo4j-ndl/react';
import { useEffect, useState } from 'react';

const catalog = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Aura', value: 'aura' },
  { label: 'Bloom', value: 'bloom' },
  { label: 'Browser', value: 'browser' },
  { label: 'Cypher', value: 'cypher' },
  { label: 'Data Importer', value: 'data-importer' },
  { label: 'GraphQL', value: 'graphql' },
];

const SEARCH_DELAY_MS = 600;

const Component = () => {
  const [searchValue, setSearchValue] = useState('');
  const [options, setOptions] = useState<typeof catalog>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (!hasOpened) {
      return;
    }

    let isCancelled = false;
    const query = searchValue.trim().toLowerCase();

    setIsLoading(true);
    setOptions([]);

    const timeoutId = window.setTimeout(() => {
      if (isCancelled) {
        return;
      }

      setOptions(
        query === ''
          ? catalog
          : catalog.filter((option) =>
              option.label.toLowerCase().includes(query),
            ),
      );
      setIsLoading(false);
    }, SEARCH_DELAY_MS);

    return () => {
      isCancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [hasOpened, searchValue]);

  return (
    <div className="n-flex n-flex-col n-gap-token-4">
      <Combobox
        label="Products"
        // The consumer supplies already-filtered options, so internal
        // filtering must be disabled.
        filterOption={false}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onOpenChange={(isOpen) => {
          if (isOpen) {
            setIsLoading(true);
            setHasOpened(true);
          }
        }}
        options={options}
        isLoading={isLoading}
        searchPlaceholder="Search products"
      />
      <Typography variant="body-small" className="n-text-neutral-text-weak">
        The consumer clears, fetches, and filters options after a short delay.
        The loading state is shown while each request is in flight.
      </Typography>
    </div>
  );
};

export default Component;
